import {arahubAPI} from "config/axios";
import {API_ARABOXCONFIG_URL} from "config";
import { mockResolve } from 'helpers';

const API_ROUTE = "dev_tools";

const convertToGeoCode = async (_data)=>{
  try{
    const {data} = await arahubAPI.post(`${API_ARABOXCONFIG_URL}${API_ROUTE}/address_to_geo`, _data, {
      responseType: "blob"
    });
    return data;
  }catch (err) {
    return Promise.reject(err.response);
  }
  // return mockResolve(true,8000,{ok:"ok"}); /** TEST MOCK */
}

const generateNearbyScreens = async (props)=>{
  const{
    fData,
    countValue,
    type,
  }=props;
  try{
    const {data} = await arahubAPI.post(`${API_ARABOXCONFIG_URL}${API_ROUTE}/get_screens_to_locations?screens_amount=${countValue}&screen_type=${type}`,
      fData, {
      responseType: "blob"
    });
    return data;
  }catch (err) {
    return Promise.reject(err.response);
  }
}

const toolsService={
  convertToGeoCode,
  generateNearbyScreens,
}

export default toolsService;